import React, {useState} from 'react';
import {Stars, ExpandButton} from "../../../../../general";
import {useProductAttributes} from '../../../state';
import {useProductViewState} from "../../../state";
import {useFormContext} from 'react-hook-form';
import {ErrorMessage} from "@hookform/error-message";
import {FieldError} from 'react-hook-form';
import {FormattedMessage, useIntl} from 'react-intl';

export const ReviewFormInner = () => {
    const {productSku, productName} = useProductAttributes() || {};
    const {handleAddReview, neededRating} = useProductViewState()!;
    const intl = useIntl();

    const {
        register,
        formState: {errors},
        setError,
        clearErrors,
        handleSubmit
    } = useFormContext();

    const [rating, setRating] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const [formSubmitted, setFormSubmitted] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const validateRating = () => {
        if (rating === 0) {
            setError('starRating', {
                type: 'manual',
                message: intl.formatMessage({id: 'review_rating_required'})
            });
            return false;
        }
        clearErrors('starRating');
        return true;
    };

    const ratingId = neededRating?.id

    const onSubmit = (data) => {
        if (!validateRating()) return;

        const selectedValueId = neededRating?.values[rating - 1]?.value_id;

        const dataObj = {
            sku: productSku,
            nickname: data.nickname,
            summary: data.summary,
            text: data.text,
            ratings: [
                {
                    id: ratingId,
                    value_id: selectedValueId
                }
            ]
        };

        handleAddReview(dataObj);
        setFormSubmitted(true);
        setIsModalOpen(true);
    }

    return (
        <div className={'react-css relative rounded-xl bg-white xl:mb-10 mb-5'} id={'review-form'}>
            {!formSubmitted && (
                <div
                    className={`react-css overflow-hidden transition-all duration-300 ${isExpanded ? 'max-h-full' : 'max-h-[450px]'} p-0 xl:p-6`}>
                    <form
                        className={'react-css rounded-xl bg-cards-bg p-4 xl:p-6 block mb-6 mt-6 xl:mt-0 shadow-custom-box-shadow'}
                        onSubmit={handleSubmit(onSubmit)}>
                        <div className={'react-css flex flex-col items-start justify-start mb-6 gap-2'}>
                            <p className={'react-css text-custom-gray font-nunito text-lg leading-4 hover:text-current'}>
                                <FormattedMessage id="review_write_for"/>
                            </p>
                            <span
                                className={'react-css text-custom-gray font-montserrat font-bold text-center text-2xl'}>{productName}
                            </span>
                        </div>
                        <div className={'react-css flex flex-col items-start justify-start mb-7'}>
                        <span
                            className={'react-css font-montserrat font-bold text-custom-gray text-lg'}>
                            <FormattedMessage
                            id="product_review_rating"/>
                        </span>
                            <span
                                className={'react-css flex flex-row items-center justify-start gap-1 text-custom-gray'}>
                   <Stars
                       totalStars={0}
                       starSize={'h-12 w-12'}
                       isInteractive
                       onStarSelect={(selectedRating) => {
                           setRating(selectedRating);
                           if (errors.starRating) {
                               clearErrors('starRating');
                           }
                       }}
                   />
                                {errors.starRating && <span
                                    className={'error-message text-red-500 text-base'}>{(errors.starRating as FieldError).message}</span>}

                </span>
                        </div>
                        <div className={'react-css flex flex-col items-start justify-start mb-6 gap-2'}>
                            <div
                                className={'react-css flex flex-col items-start xl:flex-row xl:items-center justify-between gap-5 w-full mb-6'}>
                                <div className={'react-css flex flex-col items-start justify-start gap-2 w-full'}>
                                    <p className={'react-css text-custom-gray font-nunito text-lg leading-4 hover:text-current'}>
                                        <FormattedMessage id="review_username_label"/>
                                    </p>
                                    <input
                                        {...register('nickname', {
                                            required: {
                                                value: true,
                                                message: intl.formatMessage({id: 'review_username_required'})
                                            },
                                            maxLength: {
                                                value: 30,
                                                message: intl.formatMessage({id: 'review_username_length1'})
                                            }
                                        })}
                                        placeholder={intl.formatMessage({id: 'review_username_placeholder'})}
                                        className={'react-css text-custom-gray font-montserrat font-normal text-left text-base rounded-3xl border border-gray-400 w-full h-12 p-4'}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="nickname"
                                        render={({message}) => <span
                                            className={'error-message text-red-500 text-base'}>{message}</span>}
                                    />
                                </div>
                            </div>
                            <div className={'react-css flex flex-col items-start justify-start gap-2 w-full mb-6'}>
                                <p className={'react-css text-custom-gray font-nunito text-lg leading-4 hover:text-current'}>
                                    <FormattedMessage id="review_title_label"/>
                                </p>
                                <input
                                    {...register('summary', {
                                        required: {
                                            value: true,
                                            message: intl.formatMessage({id: 'review_title_required'})
                                        },
                                        maxLength: {
                                            value: 50,
                                            message: intl.formatMessage({id: 'review_username_length2'})
                                        }
                                    })}
                                    // placeholder={intl.formatMessage({id: 'review_title_label'})}
                                    className={'react-css text-custom-gray font-montserrat font-normal text-left text-base rounded-3xl border border-gray-400 w-full h-12 p-4'}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="summary"
                                    render={({message}) => <span
                                        className={'error-message text-red-500 text-base'}>{message}</span>}
                                />
                            </div>
                            <div className={'react-css flex flex-col items-start justify-start gap-2 w-full mb-6'}>
                                <p className={'react-css text-custom-gray font-nunito text-lg leading-4 hover:text-current'}>
                                    <FormattedMessage id="review_content_label"/>
                                </p>
                                <textarea
                                    {...register('text', {
                                        maxLength: {
                                            value: 1000,
                                            message: intl.formatMessage({id: 'review_content_limit'})
                                        }
                                    })}
                                    placeholder={intl.formatMessage({id: 'review_content_placeholder'})}
                                    rows={6}
                                    className={'react-css text-custom-gray font-montserrat font-normal text-left text-base rounded-3xl border border-gray-400 w-full h-auto min-w-[150px] p-4'}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="text"
                                    render={({message}) => <span
                                        className={'error-message text-red-500 text-base'}>{message}</span>}
                                />
                            </div>
                        </div>

                        {/*Submit button*/}
                        <div className={'react-css flex items-center justify-center align-center gap-2 w-full mb-6'}>
                            <button type="submit"
                                    className={
                                        "rounded-full bg-first-btn-bg hover:bg-first-btn-bg focus:bg-first-btn-bg " +
                                        "font-montserrat font-bold text-lg text-center text-white focus:text-white hover:text-white " +
                                        "shadow-first-btn-shadow transform hover:translate-y-1 mt-2 w-80 py-3 px-4 " +
                                        "flex items-center justify-center"
                                    }>
                                <FormattedMessage id="review_submit_button"/>
                            </button>
                        </div>
                    </form>
                </div>
            )}
            {/* opacity efect over the closed div */}

            <div
                className={`react-css absolute top-0 left-0 w-full h-full transition-all duration-300 ${isExpanded ? 'hidden' : 'bg-custom-gradient'} rounded-2xl`}>
            </div>
            {/* The "See More/Less" button */}
            {!formSubmitted && (
                <div className={'react-css flex items-center justify-center xl:mb-0 mb-5'}>
                    <ExpandButton
                        isExpanded={isExpanded}
                        onClick={toggleExpand}
                        expandedText={intl.formatMessage({id: 'btn_hide_info'})}
                        collapsedText={intl.formatMessage({id: 'btn_show_info'})}
                    />
                </div>
            )}
            {isModalOpen && (
                <div className={'z-10 react-css fixed top-0 left-0 w-full h-full flex items-center justify-center'}>
                    <div
                        className={'react-css bg-background-gray p-6 rounded-xl shadow-lg w-96 p-6 z-50 absolute top-24 ' +
                            'flex items-center justify-center flex-col border-solid border-2 border-main-orange rounded-xl'}>
                        <div
                            className={'react-css fixed top-0 left-0 w-full h-full flex items-center justify-center z-10'}>
                            <div
                                className={'react-css bg-white p-6 rounded-xl shadow-lg w-96 p-6 z-50 absolute top-24'}>
                                <h2 className={'react-css text-2xl mb-4'}><FormattedMessage id="review_success_title"/>
                                </h2>
                                <p><FormattedMessage id="review_success_message"/></p>
                                <button
                                    onClick={() => setIsModalOpen(false)}
                                    className={'react-css mt-4 bg-main-orange text-white px-4 py-2 rounded hover:bg-main-orange'}
                                    type="button"
                                >
                                    <FormattedMessage id="review_close_modal"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
